import { useEffect, useRef, useState } from 'react'

import { useSelector } from 'react-redux'
import { Button, Progress } from 'antd'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'

const DEFAULT_DELAY_IN_SECONDS = 5
const ONE_SECOND = 1000
const TICK = 50

const RedirectToLoginCountdown = ({ delay = DEFAULT_DELAY_IN_SECONDS, onRedirect }) => {
  const t = useSelector(selectTranslate)

  const total = delay * ONE_SECOND

  const [remaining, setRemaining] = useState(total)

  // A caller passing an inline arrow would otherwise restart the countdown on every render.
  const redirectRef = useRef(onRedirect)
  redirectRef.current = onRedirect

  useEffect(() => {
    const intervalId = setInterval(
      () => setRemaining(remaining => Math.max(remaining - TICK, 0)),
      TICK
    )

    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    if (remaining === 0) {
      redirectRef.current()
    }
  }, [remaining])

  return (
    <div className='portal-redirect'>
      <Progress
        type='circle'
        width={110}
        strokeColor='#224a95'
        strokeWidth={8}
        percent={(remaining / total) * 100}
        format={() => Math.ceil(remaining / ONE_SECOND)}
      />

      <h1 className='title'>{t('portal_login_redirect.title')}</h1>

      <p className='message'>{t('portal_login_redirect.message')}</p>

      <Button
        className='logo-colored-button blue blue-ghost-hover w-100'
        size='large'
        type='primary'
        onClick={() => redirectRef.current()}
      >
        {t('portal_login_redirect.now')}
      </Button>
    </div>
  )
}

export default RedirectToLoginCountdown
